import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import type { MeResponse } from '@/lib/api';

type Papel = MeResponse['papel'];

/**
 * Guard de papel como rota-layout. Antes, `/app/admin/*` era acessível por qualquer
 * usuário autenticado — só o menu escondia os links, e a proteção real era o 403 do
 * backend, que nenhuma tela tratava.
 *
 * Redireciona em vez de mostrar 403: quem chegou aqui digitando a URL não tem
 * nada a fazer nesta tela, e um beco sem saída é pior que voltar ao início.
 * Isto NÃO substitui a autorização do backend — é só UX.
 */
export function RequireRole({ roles }: { roles: Papel[] }) {
  const user = useAuthStore((s) => s.user);

  // O AppLayout, que é o pai, já garante que existe sessão antes de renderizar filhos.
  if (!user) return null;
  if (!roles.includes(user.papel)) return <Navigate to="/app" replace />;

  return <Outlet />;
}

export function AdminGuard() {
  return <RequireRole roles={['HospitalAdmin', 'GlobalAdmin']} />;
}
